/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    current: PropTypes.bool,
    complete: PropTypes.bool,
    numbered: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'a',
    current: false,
    complete: false,
    numbered: false,
};

const ProgressIndicatorItem = (props) => {
    const classNames = [
        'c-progress-indicator__item',
        props.current ? 'c-progress-indicator__item--current' : '',
        props.complete ? 'c-progress-indicator__item--complete' : '',
        props.numbered ? 'c-progress-indicator__item--numbered' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            title={`Aller à l'étape : ${props.text}`}
            data-content={`${props.icon}`}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div className="c-progress-indicator__item-progress-bar" />
            {props.text}
        </props.componentClass>
    );
};

ProgressIndicatorItem.propTypes = propTypes;

ProgressIndicatorItem.defaultProps = defaultProps;

export default ProgressIndicatorItem;
